import React from "react";
import Card from "./Card";
import Leaf from '../../assets/leaf.svg';
import Therapy from '../../assets/therapy.svg';
import Massage from '../../assets/massage.svg';
import Individual from '../../assets/individual.svg';
import Analysis from '../../assets/analysis.svg';
import Aroma from '../../assets/aroma.svg';
import Coach from '../../assets/coach.svg';
import Healthcare from '../../assets/healthcare.svg';
import Detoxicity from '../../assets/detoxicity.svg';
import { motion } from "framer-motion";

const About = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .2, ease: "easeInOut" }}
        >
            <div className="py-10 w-full text-3xl font-bold text-green-main mb-4 relative md:py-14">
                <h1 className="mx-auto w-fit relative before:absolute after:absolute before:w-1/2 after:w-1/2 md:before:w-full md:after:w-full before:h-[1px] after:h-[1px] before:bg-green-main after:bg-green-main before:top-1/2 after:top-1/2 before:right-full after:left-full before:mr-2 after:ml-2">O Nas</h1>
            </div>
            <div className="flex flex-col justify-center items-center max-w-7xl mx-auto px-4 text-gray-900">
                <div className="flex flex-col justify-center items-center py-4">
                    <p>Witamy w <span className="text-green-main font-bold">Natur Med</span> – gabinecie terapii naturalnych, który powstał z myślą o osobach pragnących zadbać o swoje zdrowie w sposób bezpieczny i zgodny z naturą. Naszą misją jest wspieranie organizmu w jego naturalnych procesach samoleczenia poprzez holistyczne podejście, które obejmuje nie tylko ciało, ale także umysł. Każda osoba, która odwiedza nasz gabinet, otrzymuje indywidualnie dostosowaną pomoc oraz pełne wsparcie w dążeniu do lepszego samopoczucia i harmonii.</p>
                </div>
                <div className="flex flex-col justify-center items-center py-4">
                    <h4 className="pb-6 text-3xl font-bold text-green-main">Co oferujemy?</h4>
                    <ul className="flex flex-col justify-center items-center gap-4 md:grid grid-cols-3 grid-rows-2 md:gap-6">
                        <Card 
                            title="Konsultacje Naturopatyczne"
                            content="Każde spotkanie rozpoczynamy od uważnego wysłuchania potrzeb i oczekiwań pacjenta, co pozwala nam lepiej zrozumieć indywidualne cele zdrowotne i dostosować metody terapii."
                            icon={Leaf}
                            alt="leaf"
                        />
                        <Card 
                            title="Szczegółowa analiza stanu zdrowia z wykorzystaniem biorezonansu"
                            content="Biorezonans to nowoczesne narzędzie diagnostyczne, które pozwala na ocenę ogólnego stanu organizmu. Dzięki temu jesteśmy w stanie precyzyjnie dobrać terapie i lepiej odpowiedzieć na potrzeby zdrowotne pacjenta."
                            icon={Analysis}
                            alt="analysis"
                        />
                        <Card 
                            title="Szczegółowy indywidualny plan terapeutyczny"
                            content="Na podstawie analizy i konsultacji przygotowujemy indywidualny plan działań, uwzględniający zarówno terapie, jak i zalecenia dotyczące stylu życia, diety oraz wsparcia emocjonalnego."
                            icon={Individual}
                            alt="individual"
                        />
                        <Card 
                            title="Terapie naturalne i ziołolecznictwo"
                            content="Stosujemy szeroką gamę terapii opartych na naturalnych metodach, takich jak ziołolecznictwo i aromaterapia. Wspierają one organizm, pomagają w detoksykacji i wzmacniają odporność."
                            icon={Therapy}
                            alt="therapy"
                        />
                        <Card 
                            title="Aromaterapia"
                            content="Olejki eteryczne są wykorzystywane do redukcji stresu, poprawy jakości snu oraz wzmacniania zdrowia fizycznego i psychicznego."
                            icon={Aroma}
                            alt="aroma"
                        />
                        <Card 
                            title="Terapia Bowena"
                            content="Ta wyjątkowa technika manualna, oparta na delikatnych ruchach, pomaga uwolnić napięcia w ciele, wspierając naturalną równowagę i procesy regeneracyjne organizmu."
                            icon={Massage}
                            alt="massage"
                        />
                        <Card 
                            title="Programy zdrowotne i odchudzające"
                            content="Dla osób chcących poprawić swoje zdrowie lub zredukować wagę, przygotowujemy dedykowane programy zdrowotne oraz odchudzające, które obejmują zarówno dietę, jak i aktywność fizyczną dostosowaną do potrzeb pacjenta."
                            icon={Healthcare}
                            alt="healthcare"
                        />
                        <Card 
                            title="Programy detoksykacyjne"
                            content="Dla osób chcących poprawić swoje zdrowie lub zredukować wagę, przygotowujemy dedykowane programy zdrowotne oraz odchudzające, które obejmują zarówno dietę, jak i aktywność fizyczną dostosowaną do potrzeb pacjenta."
                            icon={Detoxicity}
                            alt="detoxicity"
                        />
                        <Card 
                            title="Coaching zdrowotny"
                            content="Nasz coaching zdrowotny ma na celu wsparcie pacjenta w budowaniu zdrowych nawyków i wprowadzaniu zmian w życiu, które będą sprzyjać lepszemu samopoczuciu i długotrwałej poprawie zdrowia."
                            icon={Coach}
                            alt="coach"
                        />
                    </ul>    
                </div>
                <div className="flex flex-col justify-center items-center py-6 md:items-start">
                    <h4 className="text-green-main text-xl font-bold mb-2 md:text-3xl">Programy detoksykacyjne</h4>
                    <p>Nasze programy detoksykacyjne to wieloetapowe procesy, które mają na celu oczyszczenie organizmu z toksyn nagromadzonych w wyniku działania czynników środowiskowych, niewłaściwej diety, stresu czy braku aktywności fizycznej. Oferujemy indywidualnie dobrane plany detoksykacyjne, które mogą obejmować:</p>
                    <ul className="mb-2 mt-4 list-disc px-3 md:max-w-3xl md:ml-24">
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Wprowadzenie zbilansowanej diety oczyszczającej –</span> Zalecamy dietę opartą na naturalnych produktach, bogatą w składniki odżywcze, które wspierają pracę wątroby, nerek oraz układu trawiennego, przyspieszając proces eliminacji toksyn.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Wsparcie ziołolecznictwem –</span> Stosujemy odpowiednio dobrane mieszanki ziół wspomagające detoksykację organizmu, co pozwala na delikatne, ale skuteczne oczyszczanie.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Techniki relaksacyjne i masaże –</span> Masaże, takie jak terapia Bowena, pomagają uwolnić napięcia i stres, wspierając organizm w procesie oczyszczania oraz regeneracji.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Porady dotyczące stylu życia –</span> Skupiamy się na wprowadzeniu zdrowych nawyków, takich jak regularna aktywność fizyczna, odpowiednia ilość snu oraz unikanie substancji toksycznych, by efekty detoksykacji były trwałe.
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col justify-center items-center pb-6 md:items-start">
                    <h4 className="text-green-main text-xl font-bold mb-2 md:text-3xl">Programy walki z chorobami cywilizacyjnymi</h4>
                    <p>Choroby cywilizacyjne, takie jak cukrzyca, nadciśnienie, otyłość, choroby serca i depresja, są często wynikiem niewłaściwego stylu życia, niezdrowej diety, braku aktywności fizycznej oraz stresu. Nasze programy zdrowotne wspierają pacjentów w walce z tymi schorzeniami, stosując naturalne i holistyczne podejście, które obejmuje:</p>
                    <ul className="mb-2 mt-4 list-disc px-3 md:max-w-3xl md:ml-24">
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Szczegółową analizę stanu zdrowia –</span> Wykorzystujemy metody diagnostyczne, takie jak biorezonans, aby określić indywidualne potrzeby pacjenta i zrozumieć źródła problemów zdrowotnych.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Indywidualne plany dietetyczne –</span> Dieta odgrywa kluczową rolę w profilaktyce i leczeniu chorób cywilizacyjnych, dlatego przygotowujemy zbilansowane plany żywieniowe oparte na naturalnych produktach, które pomagają regulować poziom cukru, cholesterolu oraz ciśnienia.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Coaching zdrowotny –</span> Wspieramy pacjentów w budowaniu zdrowych nawyków, takich jak regularna aktywność fizyczna, redukcja stresu oraz zdrowe podejście do relaksu i regeneracji.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Suplementacja i ziołolecznictwo –</span> Dobieramy odpowiednie suplementy i mieszanki ziół, które wspierają układ sercowo-naczyniowy, metaboliczny oraz poprawiają odporność.
                            </p>
                        </li>
                        <li className="mb-3 text-green-main">
                            <p className="text-gray-900">
                                <span className="text-green-main font-bold">Wsparcie emocjonalne i techniki relaksacyjne –</span> Wprowadzamy techniki relaksacyjne, jak medytacja i aromaterapia, które pomagają w radzeniu sobie ze stresem, będącym często przyczyną chorób cywilizacyjnych.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </motion.div>
    );
};

export default About;